"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#APIExtensionAsset',
    assetType: 'APIExtension'
  },
  owner: {
    gusTeam: 'MS ALS',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in0JYAQ/view'
  },
  name: 'API Extension',
  pluralName: 'API Extensions',
  visibility: 'private',
  featureFlag: 'api-extension-enabled',
  publication: {
    inferredBy: [{
      classifiers: ['api-extension']
    }],
    files: [{
      id: 'fat-api-extension',
      classifier: 'fat-api-extension',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip'
    }, {
      id: 'light-api-extension',
      classifier: 'light-api-extension',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip',
      usedAsDependency: true
    }, {
      id: 'api-extension',
      classifier: 'api-extension',
      mainFileLocationProperty: 'mainFile',
      packaging: 'zip'
    }],
    minimumInputSets: [{
      files: ['api-extension'],
      requiredProperties: ['mainFile']
    }],
    extensionPoints: [{
      name: 'filesGenerator',
      config: {
        outputFileIds: ['light-api-extension', 'fat-api-extension']
      }
    }],
    ootbSteps: [{
      name: 'angModelExtraction'
    }]
  }
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map